'use strict';

window.TES = window.TES || {};

window.TES.User = function(userId) {
    this._userId = userId;
};

window.TES.User.prototype = {

    _userId: null,

    isAuthenticated: function () {
        return !!this._userId;
    },

    getId: function () {
        return this._userId;
    }
};
